import React, { Fragment } from "react";
import "./BookRegister.css";
import { postBook } from "../../services/Book";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { Creators as LoaderActions } from "../../store/ducks/loader";
import Modal from "../Modal";
import ModalContentMessage from "../ModalContentMessage";

class BookRegister extends React.Component {
  constructor(props) {
    super(props);
      window.scrollTo(0, 0);
    this.state = {
      openModal: false,
      title: "",
      subTitle: "",
      authors: "",
      organizers: "",
      category: "",
      numberEdition: "",
      amountPages: "",
      amountWords: "",
      synopsis: "",
      completePresentation: "",
      haveImagesGraphOurTable: false,
      publishEbook: false,
      amountBooks: ""
    };
    this.handleFormSubmit = this.handleFormSubmit.bind(this);
    this.handleCloseModal = this.handleCloseModal.bind(this);
  }
  cleanForm() {
    this.setState({
      title: "",
      subTitle: "",
      email: "",
      authors: "",
      organizers: "",
      category: "",
      numberEdition: "",
      amountPages: "",
      amountWords: "",
      synopsis: "",
      completePresentation: "",
      haveImagesGraphOurTable: false,
      publishEbook: false,
      amountBooks: ""
    });
  }

  async handleFormSubmit(e) {
    e.preventDefault();
    const { isLoading } = this.props;
    const {
      title,
      subTitle,
      email,
      authors,
      organizers,
      category,
      numberEdition,
      amountPages,
      amountWords,
      synopsis,
      completePresentation,
      haveImagesGraphOurTable,
      publishEbook,
      amountBooks
    } = this.state;
    const data = {
      title,
      subTitle,
      email,
      authors,
      organizers,
      category,
      numberEdition,
      amountPages,
      amountWords,
      synopsis,
      completePresentation,
      haveImagesGraphOurTable,
      publishEbook,
      amountBooks
    };
    isLoading(true);
    try {
      await postBook(data);
      this.cleanForm();
      isLoading(false);
      this.setState({ openModal: true });
    } catch (Error) {
      alert("Aconteceu um error!");
    }
  }

  handleCloseModal() {
    this.setState({ openModal: false });
  }

  render() {
    const {
      title,
      subTitle,
      email,
      authors,
      organizers,
      category,
      numberEdition,
      amountPages,
      amountWords,
      synopsis,
      completePresentation,
      haveImagesGraphOurTable,
      publishEbook,
      amountBooks,
      openModal
    } = this.state;
    return (
      <Fragment>
        <div id="BookRegister" className="container mt-5">
          <h3 className="bookRegister-default-color ml-2">CADASTRO DO LIVRO</h3>
          <div className="container">
            <form onSubmit={this.handleFormSubmit}>
              <div className="row">
                <div className=" col-xl-12">
                  <div className="form-group">
                    <label className="bookregister-label" htmlFor="titulo">
                      TÍTULO
                    </label>
                    <input
                      required
                      value={title}
                      type="text"
                      className="form-control bookregister-input"
                      id="titulo"
                      onChange={e => this.setState({ title: e.target.value })}
                    />
                  </div>
                </div>
              </div>
              <div className="row">
                <div className=" col-xl-12">
                  <div className="form-group">
                    <label className="bookregister-label" htmlFor="subtitulo">
                      SUBTÍTULO <span>(se houver)</span>{" "}
                    </label>
                    <input
                      required
                      value={subTitle}
                      type="text"
                      className="form-control bookregister-input"
                      id="subtitulo"
                      onChange={e =>
                        this.setState({ subTitle: e.target.value })
                      }
                    />
                  </div>
                </div>
              </div>
              <div className="row">
                <div className=" col-xl-12">
                  <div className="form-group">
                    <label className="bookregister-label" htmlFor="autores">
                      AUTOR(ES){" "}
                    </label>
                    <input
                      required
                      type="text"
                      className="form-control bookregister-input"
                      id="autores"
                      placeholder="Coloque os nomes seperados por vírgula, ex: Gabriel, João, Maria"
                      value={authors}
                      onChange={e => this.setState({ authors: e.target.value })}
                    />
                  </div>
                </div>
              </div>
              <div className="row">
                <div className=" col-xl-12">
                  <div className="form-group">
                    <label className="bookregister-label" htmlFor="email-responsaveis">
                      EMAIL DO RESPONSÁVEL{" "}
                    </label>
                    <input
                      required
                      type="text"
                      className="form-control bookregister-input"
                      id="email-responsaveis"
                      placeholder="Digite o email do responsável"
                      value={email}
                      onChange={e => this.setState({ email: e.target.value })}
                    />
                  </div>
                </div>
              </div>
              <div className="row">
                <div className=" col-xl-12">
                  <div className="form-group">
                    <label
                      className="bookregister-label"
                      htmlFor="organizadores"
                    >
                      ORGANIZADOR(ES){" "}
                    </label>
                    <input
                      required
                      type="text"
                      className="form-control bookregister-input"
                      id="organizadores"
                      placeholder="Coloque os nomes seperados por vírgula, ex: Gabriel, João, Maria"
                      value={organizers}
                      onChange={e =>
                        this.setState({ organizers: e.target.value })
                      }
                    />
                  </div>
                </div>
              </div>
              <div className="row">
                <div className="col-xl-6">
                  <div className="form-group">
                    <label className="bookregister-label" htmlFor="categoria">
                      CATEGORIA
                    </label>
                    <input
                      required
                      value={category}
                      type="text"
                      className="form-control bookregister-input"
                      id="categoria"
                      onChange={e =>
                        this.setState({ category: e.target.value })
                      }
                    />
                  </div>
                </div>
              </div>
              <div className="row">
                <div className="col-xl-6">
                  <div className="form-group">
                    <label
                      className="bookregister-label"
                      htmlFor="quantPalavras"
                    >
                      QUANT. PALAVRAS <span>(word)</span>{" "}
                    </label>
                    <input
                      required
                      value={amountWords}
                      type="text"
                      className="form-control bookregister-input"
                      id="quantPalavras"
                      onChange={e =>
                        this.setState({ amountWords: e.target.value })
                      }
                    />
                  </div>
                </div>
                <div className=" col-xl-6">
                  <div className="form-group">
                    <label
                      className="bookregister-label"
                      htmlFor="quantPaginas"
                    >
                      QUANT. PÁGINAS <span>(word)</span>{" "}
                    </label>
                    <input
                      required
                      value={amountPages}
                      type="number"
                      className="form-control bookregister-input"
                      id="quantPaginas"
                      onChange={e =>
                        this.setState({ amountPages: e.target.value })
                      }
                    />
                  </div>
                </div>
              </div>
              <div className="row">
                <div className="col-12">
                  <div className="form-group">
                    <label className="bookregister-label" htmlFor="sinopse">
                      SINOPSE
                    </label>
                    <textarea
                      required
                      value={synopsis}
                      placeholder="Resumir em 600 caracteres com espaços. Este texto pode
                                            sofrer alterações na finalização da edição"
                      className="form-control bookregister-textarea"
                      maxLength="600"
                      rows="8"
                      id="sinopse"
                      onChange={e =>
                        this.setState({ synopsis: e.target.value })
                      }
                    />
                  </div>
                </div>
              </div>
              <div className="row">
                <div className="col-12">
                  <div className="form-group">
                    <label
                      className="bookregister-label"
                      htmlFor="apresentacaoCompleta"
                    >
                      APRESENTAÇÃO COMPLETA
                    </label>
                    <textarea
                      required
                      value={completePresentation}
                      placeholder="Caso já tenha uma apresentação completa sobre a obra insira aqui"
                      className="form-control bookregister-textarea"
                      rows="8"
                      id="apresentacaoCompleta"
                      onChange={e =>
                        this.setState({ completePresentation: e.target.value })
                      }
                    />
                  </div>
                </div>
              </div>
              <div style={{ margin: "20px 0" }} className="row">
                <div className="col-12">
                  <div className="media-container">
                    <label className="book-register-label bookregister-media-label">
                      {" "}
                      SEU LIVRO POSSUI FOTOS, GRÁFICOS OU TABELAS ?{" "}
                    </label>
                    <div className="radio-buttons-media">
                      <label className="container-label" htmlFor="op-media-sim">
                        Sim
                        <input
                          required
                          name="media-radio"
                          id="op-media-sim"
                          type="radio"
                          value="sim"
                          checked={haveImagesGraphOurTable === "sim"}
                          onChange={e =>
                            this.setState({
                              haveImagesGraphOurTable: e.target.value
                            })
                          }
                        />
                        <span className="checkmark" />
                      </label>
                      <label className="container-label" htmlFor="op-media-nao">
                        Não
                        <input
                          required
                          name="media-radio"
                          id="op-media-nao"
                          type="radio"
                          value="nao"
                          checked={haveImagesGraphOurTable === "nao"}
                          onChange={e =>
                            this.setState({
                              haveImagesGraphOurTable: e.target.value
                            })
                          }
                        />
                        <span className="checkmark" />
                      </label>
                    </div>
                  </div>
                </div>
              </div>
              <div style={{ margin: "20px 0" }} className="row">
                <div className="col-8 col-sm-8 col-md-6 col-xl-4">
                  <div className="form-group">
                    <label
                      className="book-register-label"
                      style={{ display: "block" }}
                    >
                      QUANTOS LIVROS PRETENDE AQUIRIR ?
                    </label>
                    <div className="buttons-radio-amount">
                      <label className="container-label" htmlFor="op-100">
                        100
                        <input
                          required
                          name="amount-boook-radio"
                          id="op-100"
                          type="radio"
                          value="100"
                          checked={amountBooks === "100"}
                        />
                        <span className="checkmark" />
                      </label>
                      <label className="container-label" htmlFor="op-200">
                        200
                        <input
                          required
                          name="amount-boook-radio"
                          id="op-200"
                          type="radio"
                          value="200"
                          checked={amountBooks === "200"}
                          onChange={e =>
                            this.setState({ amountBooks: e.target.value })
                          }
                        />
                        <span className="checkmark" />
                      </label>
                      <label className="container-label" htmlFor="op-300">
                        300
                        <input
                          name="amount-boook-radio"
                          id="op-300"
                          type="radio"
                          value="300"
                          checked={amountBooks === "300"}
                          onChange={e =>
                            this.setState({ amountBooks: e.target.value })
                          }
                        />
                        <span className="checkmark" />
                      </label>
                      <label className="container-label" htmlFor="op-outher">
                        OUTRA
                        <input
                          name="amount-boook-radio"
                          required
                          id="op-outher"
                          type="radio"
                          value="outro"
                          checked={amountBooks === "outro"}
                          onChange={e =>
                            this.setState({ amountBooks: e.target.value })
                          }
                        />
                        <span className="checkmark" />
                      </label>
                    </div>
                  </div>
                </div>
              </div>
              {
                this.state.amountBooks === 'outro' ? (
                  <div className="col-6 col-sm-6 col-md-5 col-xl-2 other">
                    <div className="form-group">
                      <label className="bookregister-label" htmlFor="numberBooks">
                        DIGITE AQUI
                      </label>
                      <input
                        required
                        disabled={amountBooks !== "outro"}
                        type="text"
                        className="form-control bookregister-input"
                        id="numberBooks"
                      />
                    </div>
                  </div>
                ) : null
              }
              <div className="button-book-row mt-4 mb-4">
                <button type="submit">Enviar</button>
              </div>
            </form>
          </div>
        </div>
        <Modal open={openModal} onClose={this.handleCloseModal}>
          <ModalContentMessage
            onCLickButton={this.handleCloseModal}
            message="Livro salvo com sucesso!"
          />
        </Modal>
      </Fragment>
    );
  }
}

const mapDispatchToProps = dispatch =>
  bindActionCreators(LoaderActions, dispatch);

export default connect(
  null,
  mapDispatchToProps
)(BookRegister);



// WEBPACK FOOTER //
// ./src/components/BookRegister/BookRegister.js